import { gql } from 'urql'
export const FragFacetInfo = gql`
  fragment FacetInfo on FacetInfo {
    facetsUsed
    facetsAvailable {
      categories {
        count
        name
        active
      }
      guides {
        count
        name
        active
      }
    }
  }
`
